import {Text} from 'platform/foundation';

import {translateWithFallback as t} from '../../utils/translateWithFallback';

/** Labels the catalogue photo shown when the car has none: it shows neither its paint nor its options. */
export function IllustrativePhotoCaption() {
  return (
    <Text size="xSmall" color="secondary">
      {t('general.labels.illustrativePhoto', 'Illustrative photo')}
    </Text>
  );
}
